const regV4 =
  /^(1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|[1-9])\.(1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|\d)\.(1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|\d)\.(1\d{2}|2[0-4]\d|25[0-5]|[1-9]\d|\d)$/;

const regV6 =
  /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;

//安全密码强度
const minSafePwdLevel = 3;

/**
 * 验证url是否合法
 * @param {string} url, 目标url
 * @param {string} origin，域名
 * @returns {boolean}，是否合法
 *
 */
export function checkIsLegalUrl(url: string, origin: string): boolean {
  if (!origin || !url) return false;
  const regExp = new RegExp("^(http://|https://)(\\w+\\.)?" + origin + "($|/.*|\\?.*)", "i");
  return regExp.test(url);
}

/**
 * @param {string} ip 目标ip
 * @returns {boolean} 是否是合法的ip
 */
export function validateIp(ip: string): boolean {
  const trimIp = ip ? ip.trim() : "";
  let flag = false;
  if (trimIp && (regV4.test(trimIp) || regV6.test(trimIp))) {
    flag = true;
  } else {
    flag = false;
  }
  return flag;
}

/**
 *
 * @param {string} ips 多个ip字符串
 * @param {string｜RegExp} sep 分割符如：逗号, 换行符
 * @returns {boolean} 是否是合法的ip
 */
export function validateIps(ips: string, sep = ","): boolean {
  const ipList = ips ? ips.split(sep) : [];
  const trimIps = ipList.filter((item) => item.trim() !== "");
  const flag = trimIps.every((ip) => regV4.test(ip) || regV6.test(ip));
  return flag;
}

/**
 *
 * @param {string} value 邮箱
 * @returns {boolean} 是否是合法的邮箱
 */
export function validEmail(value: string): boolean {
  const reg = /^([a-zA-Z0-9_.-])+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-zA-Z]{2,}$/;
  return reg.test(value);
}

/**
 *
 * @param {string} value 手机号
 * @returns {boolean} 是否是合法的手机号
 */
export function validPhone(value: string): boolean {
  const reg = /^[0-9]{5,11}$/;
  return reg.test(value);
}

/**
 * 检测密码强度
 * @param {string} pwd，密码字符串
 * @returns {number} 具体等级
 */
export function checkPwdStrength(pwd: string): number {
  let level = 0;
  if (pwd.length >= 6 && pwd.length <= 20) {
    //正则表达式验证符合要求的
    if (/\d/.test(pwd)) level++; //数字
    if (/[a-z]/.test(pwd)) level++; //小写
    if (/[A-Z]/.test(pwd)) level++; //大写
    if (/\W/.test(pwd)) level++; //特殊字符
    if (level > 1 && pwd.length > 12) level++; //超过12位并且两种组合以上
  }
  return level;
}

/**
 *
 * @param {"email" | "likePhone" | "dynamicCode" | "recommendCode" | "loginPassword" | "securityPassword"} type 校验的类型以上中的一个
 * @param {string} content 校验的实际内容
 * @param {boolean} retRegExp true 直接返回对应的正则表达式
 * @returns
 */
export function regexp(
  type: "email" | "likePhone" | "dynamicCode" | "recommendCode" | "loginPassword" | "securityPassword",
  content: string,
  retRegExp?: boolean
) {
  const verify = {
    email: /^([a-zA-Z0-9_\.-])+@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\.)+[a-zA-Z]{2,}$/,
    // allNumber: /^[0-9]*$/, //废弃
    likePhone: /^[0-9]{5,11}$/, //7位数字显示国家代码
    dynamicCode: /^[0-9]{6}$/, //6位动态验证码
    recommendCode: /^[A-Z0-9a-z]{6,10}$/, //邀请码
    loginPassword: /^(?!.*\s)(?!^[\u4e00-\u9fa5]+$).{8,1000}$/, //新的登录密码
    securityPassword: /^(?![\d]+$)(?![a-zA-Z]+$)(?![!@#\$%\^&\*\(\)]+$)[\da-zA-Z!@#\$%\^&\*\(\)]{6,20}$/, //新的安全密码
  };
  if (!verify[type]) return;
  if (retRegExp) return verify[type];
  return verify[type].test(content);
}
